import { usePracticeAccess } from '@hb/react'
import { Encounter, ENCOUNTERS, EncounterType, isDev } from '@hb/shared'
import { collection, CollectionReference, orderBy, query, where } from 'firebase/firestore'
import { useMemo } from 'react'
import { db } from '../../../backend/db'
import { useQuery } from '../useQuery'

const getEncounterQuery = (
  type: EncounterType | null,
  practiceId: string | null,
  patientId: string | null | undefined,
  assessmentId?: string | null,
) => {
  // TODO: remove this after testing
  if (!isDev) return null
  if (!patientId) return null
  let q = query(
    collection(db, ENCOUNTERS) as CollectionReference<Encounter>,
    where('patientId', '==', patientId),
  )
  if (type) {
    q = query(q, where('type', '==', type))
  }
  if (practiceId) {
    q = query(q, where('practiceId', '==', practiceId))
  }
  if (assessmentId) {
    q = query(q, where('assessmentId', '==', assessmentId))
  }

  return query(q, orderBy('date', 'desc'))
}

export const usePatientEncounters = (
  type: EncounterType | null,
  patientId: string | null | undefined,
  assessmentId?: string | null,
) => {
  const { selectedPracticeId } = usePracticeAccess()

  const usedAssessmentId = useMemo(() => {
    switch (type) {
      case EncounterType.ANTEPARTUM:
      case EncounterType.POSTPARTUM:
      case EncounterType.BIRTHING_CENTER_ADMISSION:
        return assessmentId
      default:
        return null
    }
  }, [type, assessmentId])

  const ref = useMemo(
    () => getEncounterQuery(type, selectedPracticeId, patientId, usedAssessmentId),
    [patientId, type, selectedPracticeId, usedAssessmentId],
  )
  return useQuery<Encounter>(ref)
}
